// AUTO-GENERATED by asyncapi-cable from the cable AsyncAPI documents.
// Do not edit by hand — regenerate with the asyncapi-cable CLI.

import { Channel } from "@anycable/core";
import type { AppVersionMessage } from "../models/AppVersionMessage";

/** Alternatives declared for the operation — AsyncAPI treats a channel's messages as a union. */
export type AppVersionData = AppVersionMessage;

/** Params the client supplies at subscribe time. */
export type AppVersionParams = Record<string, never>;

export class AppVersionChannel extends Channel<AppVersionParams, AppVersionData> {
  static identifier = "AppVersionChannel";
}
